export default class Sponsorship {
  readonly "@id"?: string;
  readonly "@type"?: string;
  readonly "@context"?: string;
  readonly id?: number;

  refferalCode?: string;
  mail?: string;
  students?: number;
  fees?: number;
  periode?: number;
  filleul?: any;
  statut?: string

  readonly lastModificationDatetime?: Date;
  readonly creationDatetime?: Date;

  constructor(refferalCode: string) {
    this.refferalCode = refferalCode;
  }
}
